/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ICommonData } from "Interfaces/SiteContent/ICommonData";

import {
  COMMON_DATA_LOAD,
  COMMON_DATA_LOAD_FAIL,
  COMMON_DATA_LOAD_SUCCESS,
} from "./CommonDataActionTypes";

/**
 * Action for getting the common data.
 */
export interface ICommonDataLoad {
  type: typeof COMMON_DATA_LOAD;
}

/**
 * Action when common data is loaded successfully.
 */
export interface ICommonDataLoadSuccess {
  type: typeof COMMON_DATA_LOAD_SUCCESS;
  commonData: ICommonData;
}

/**
 * Action when common data load fails.
 */
export interface ICommonDataLoadFail {
  type: typeof COMMON_DATA_LOAD_FAIL;
  commonDataLoadError: string;
}

/**
 * Action for loading the common data.
 * @returns {ICommonDataLoad}
 */
export const loadCommonData = (): ICommonDataLoad => ({
  type: COMMON_DATA_LOAD,
});

/**
 * Action for getting the common data success.
 * @returns {ICommonDataLoad}
 */
export const getCommonDataSuccess = (commonData: ICommonData): ICommonDataLoadSuccess => ({
  type: COMMON_DATA_LOAD_SUCCESS,
  commonData,
});

/**
 * Action when common data fails to load.
 * @returns {ICommonDataLoadFail}
 */
export const getCommonDataFailure = (commonDataLoadError: string): ICommonDataLoadFail => ({
  type: "COMMON_DATA_LOAD_FAIL",
  commonDataLoadError,
});

export type CommonDataActionTypes = ICommonDataLoad | ICommonDataLoadSuccess | ICommonDataLoadFail;
